export const debounce = (callback, delay) => {
    let timer = null;
    return (...args) => {
        timer && clearTimeout(timer);
        timer = setTimeout(() => callback(...args), delay);
    };
};
